import { handle } from '@modules/professional/page/InfoPage';
import { loader } from '@modules/professional/api/info-page-loader.server';
import InfoPage from '@modules/professional/page/info/InfoPage';

export { loader, handle };
export default InfoPage;
